<template>
    <font-awesome-icon
        :icon="['fas', 'lock-keyhole']"
        class="disabled-icon"
        :aria-label="ariaLabelText"
        v-tooltip="tooltipText"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    accessLevel?: string | null;
    tooltip?: string | null;
}>();

const ariaLabelText = computed<string>(() => (
    props.accessLevel ? `No access - Requires ${props.accessLevel}` : 'No access'
));
const tooltipText = computed<string>(() => props.tooltip || ariaLabelText.value);

</script>

<style lang="scss" scoped>
.disabled-icon {
    font-size: var(--smallFontSize);
    color: var(--accentColour);
}

</style>
